// extracted by mini-css-extract-plugin
export default {"container":"assignedKitList_container__klwzo"};